import { CartItemDesign } from "../models/CartItem";
import { DesignLogo } from "../../../../core/models/entities/Design";
import { useAddLogoToOrderDialog } from "../../../components/Dialogs/add-logo-to-design-order-dialog";
import { DesignPrintItem } from "./DesignPrintItem";
import { getColorsElements } from "./ProductDetailsLogo";

interface OrderLineViewDesignPrintProps {
  orderline: CartItemDesign;
  designLogo: DesignLogo;
  isDeleted?: boolean;
}

export function OrderLineViewDesignPrint({
  orderline,
  designLogo,
  isDeleted,
}: OrderLineViewDesignPrintProps) {
  const views = orderline.design.style?.styleViews ?? [];
  const relevantViews = views.filter((v) => v.id == designLogo.viewId);
  const placements = relevantViews.map((x) => x.view).join("");

  const { component, open } = useAddLogoToOrderDialog(designLogo);

  const transferType = designLogo.logo.transferMethod.type.toLowerCase();
  const isEmbroidery = transferType === "broderi" || transferType === "embroidery";

  return (
    <>
      {component}
      <DesignPrintItem
        logo={designLogo.logo}
        addMoreAction={isDeleted || isEmbroidery ? undefined : open}
        placements={placements}
        colors={getColorsElements(designLogo.logo)}
        isDeleted={isDeleted}
      />
    </>
  );
}
